import { mapParamsBySchema, mapRowsBySchema } from '../../../../util';
import { apiRequest } from '../../../../Services/Common/ApiRequest';
import Global from '../../../../Services/Common/Global';
import { M_Master_BASIC_Schema } from './M_Master_BASIC_Schema';
import useSearchMutaion from '../../../../Hooks/apis/useSearchMutaion';
import useSaveMutation from '../../../../Hooks/apis/useSaveMutaion';
import useDeleteMutation from '../../../../Hooks/apis/useDeleteMutaion';

/** TBM 세션 1건 조회 getTbmNewR5 */
export const useSearch1 = (successOptions) => {
  return useSearchMutaion(async (context) => {
    const payload = mapParamsBySchema(
      M_Master_BASIC_Schema.mapper.search1,
      context
    );
    return apiRequest('post', Global.urls.ToolBoxMeeting.getTbmNewR5, payload);
  }, successOptions);
};

/** TBM 단계 조회 getTbmNewR3 */
export const useSearch2 = (successOptions) => {
  return useSearchMutaion(async (context) => {
    const payload = mapParamsBySchema(
      M_Master_BASIC_Schema.mapper.search2,
      context
    );
    return apiRequest('post', Global.urls.ToolBoxMeeting.getTbmNewR3, payload);
  }, successOptions);
};

/** TBM 참가자 조회 getTbmNewR2 */
export const useSearch3 = (successOptions) => {
  return useSearchMutaion(async (context) => {
    const payload = mapParamsBySchema(
      M_Master_BASIC_Schema.mapper.search3,
      context
    );
    return apiRequest('post', Global.urls.ToolBoxMeeting.getTbmNewR2, payload);
  }, successOptions);
};

/** TBM 단계 저장 saveTbmNewU3 */
export const useSave1 = (options = {}) => {
  return useSaveMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, M_Master_BASIC_Schema.mapper.save1);
    return apiRequest('post1', Global.urls.ToolBoxMeeting.saveTbmNewU3, payload);
  }, options);
};

/** TBM 정보 삭제 deleteTbmNewD1 */
export const useDelete1 = (options = {}) => {
  return useDeleteMutation(async (item) => {
    const payload = mapParamsBySchema(M_Master_BASIC_Schema.mapper.delete1, item);
    return apiRequest('post', Global.urls.ToolBoxMeeting.deleteTbmNewD1, [payload]);
  }, options);
};
